'use strict';

namespace Core {

    class ModalFlightDetails {

        flight: any;
        passengers: number;
        show: boolean;
        customiseMessage: boolean = false;
        showBaggageInfo: boolean = false;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private flightDetail: any
            )
        {
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('modalFlightDetails', 'showModalFlightDetails', e => {
                this.flight = e.data.flight;
                this.passengers = e.data.passengers;
                this.show = true;
                this.showBaggageInfo = TRPCONFIG.Domain.EnableFlightDetailsPopupBaggageInfo;
                this.customiseMessage = e.data.customiseMessage;
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalFlightDetails');
            });
        }

        public isHFareFlightType() {
            return this.flightDetail.isHFlightType(this.flight);
        }

    }

    angular
        .module('core')
        .directive('modalFlightDetails', (): ng.IDirective => {

        return {
            scope: {},
            controller: ModalFlightDetails,
            controllerAs: 'fdc',
            templateUrl: 'partials/home/directivetemplate?type=FlightListingDetails',

            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : ModalFlightDetails) {
                controller.init(el);
            }

        };

    });

}
